<template>
  <app-collapse class="mt-1">
    <app-collapse-item
      :is-visible="false"
      class="collapsible-section-bg"
      title="Maritime containers"
    >
      <template #header>
        <span
          class="lead collapse-title"
        >
          <section-status-icon
            :has-data="hasContainersData"
            :has-errors="hasSectionErrors"
          />
          Maritime containers
        </span>
      </template>
      <div
        v-for="(container, containerIndex) in parcel.maritime_containers"
        :key="containerIndex"
        class="border rounded pl-3 pr-3 pt-1 mb-2"
      >
        <b-row>
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Container identification number"
            >
              <b-form-group>
                <label>
                  Container identification number
                  <small class="text-muted">1907063000</small>
                  <feather-icon
                    v-b-tooltip.hover.top="'Container identification number'"
                    icon="InfoIcon"
                    size="14"
                    class="ml-50 text-muted"
                  />
                </label>
                <b-form-input
                  v-model="container.container_identification_number"
                  v-b-tooltip.hover.top="getIssueMessage(`maritime_containers.${containerIndex}.container_identification_number`)"
                  :class="getIssueClass(`maritime_containers.${containerIndex}.container_identification_number`)"
                  :disabled="disabled"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Delete Button -->
          <b-col
            cols="12"
            md="8"
            class="text-right"
          >
            <b-button
              v-if="!disabled"
              variant="link"
              size="sm"
              class="text-danger mt-2"
              @click="removeContainer(containerIndex)"
            >
              <feather-icon icon="TrashIcon" />
              Delete
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-row>
        <b-col class="text-right">
          <b-button
            v-if="!disabled"
            variant="info"
            size="sm"
            @click="addContainer"
          >
            <feather-icon icon="PlusIcon" />
            New maritime container
          </b-button>
        </b-col>
      </b-row>
    </app-collapse-item>
  </app-collapse>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import errorHighlightingMixin from '@/mixins/errorHighlightingMixin'
import SectionStatusIcon from '@/views/shipments/declarations/modals/components/h1/SectionStatusIcon.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    ValidationProvider,
    AppCollapse,
    AppCollapseItem,
    SectionStatusIcon,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [errorHighlightingMixin],
  props: {
    parcel: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasContainersData() {
      if (!this.parcel || !this.parcel.maritime_containers || !Array.isArray(this.parcel.maritime_containers)) {
        return false
      }
      return this.parcel.maritime_containers.some(container => container.container_identification_number)
    },
    hasSectionErrors() {
      return Object.keys(this.issuesMap).some(key => key.startsWith('maritime_containers.'))
    },
  },
  methods: {
    addContainer() {
      if (!this.parcel.maritime_containers) {
        this.$set(this.parcel, 'maritime_containers', [])
      }
      this.parcel.maritime_containers.push({
        container_identification_number: '',
      })
    },
    removeContainer(containerIndex) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this maritime container?', {
        title: 'Please Confirm',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'Yes',
        cancelTitle: 'No',
        centered: true,
      }).then(value => {
        if (value) {
          this.parcel.maritime_containers.splice(containerIndex, 1)
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '@core/scss/base/bootstrap-extended/variables';
@import '@core/scss/base/core/mixins/declarations-mixins';

.collapsible-section-bg {
  @include collapsible-section-bg;
}

.input-warning {
  @include input-warning;
}

.input-danger {
  @include input-danger;
}
</style>
